import React, { Component } from 'react';
import { TextField } from '@mui/material';
import i18n from '../../i18n';

/**
 * Percentage input, stored as a percentage number (15.5 means 15.5%).
 *
 * Two problems here before: a value outside 0-100 was silently dropped — the
 * validator returned early without calling onChange, and the error display was
 * commented out, so the field simply refused the keystroke with no explanation.
 * And the label was the hardcoded string "Percent" regardless of which column the
 * field was editing. The bound now lives in utils/fieldValidation.
 */
class DialogPercentField extends Component {
    render() {
        const { field, value, error, autoFocus, onBlur } = this.props;

        return (
            <TextField
                key={field.id}
                autoFocus={autoFocus}
                id={field.id}
                label={i18n.t(`columns.${field.label}`)}
                required={Boolean(field.required)}
                error={Boolean(error)}
                // A validation message replaces the static hint while it is
                // showing, as in DialogBigTextField.
                helperText={
                    error ||
                    (field.helperText
                        ? i18n.t(`helperTexts.${field.helperText}`)
                        : '')
                }
                variant="outlined"
                fullWidth
                value={value ?? ''}
                onBlur={onBlur}
                onChange={(event) =>
                    this.props.onChange(field.id, event.target.value)
                }
                InputProps={{
                    endAdornment: '%'
                }}
            />
        );
    }
}

export default DialogPercentField;
